import React from 'react';
import AdvancedTabOption from './AdvancedTabOption';

const AdvancedTabOptions = ({ inputList }) => {
  return (
    <div className="general-options-wrap">
      {
        inputList.map(item => {
          return (
            <AdvancedTabOption
              key={item.id}
              {...item}
            />
          )
        })
      }
    </div>
  )
}

export default AdvancedTabOptions;